import { useMemo } from 'react';
import { SelectField } from '../ui/field/select-field';
import { accountTypeSelectOptions } from '@liquidbudget/common';
import { UseFormReturn } from 'react-hook-form';
import { getAccountTypeIcon } from '@/components/account-form/account-icon';

interface Props {
  form: UseFormReturn<any>;
  name: string;
  label: string;
  disabled?: boolean;
}

export function AccountTypeSelectField({ form, name, label, disabled }: Props) {
  const accountTypeOptionsWithIcons = useMemo(() => {
    return accountTypeSelectOptions.map((group) => ({
      ...group,
      options: group.options.map((option) => ({
        ...option,
        icon: getAccountTypeIcon(option.value),
      })),
    }));
  }, []);

  return (
    <SelectField
      form={form}
      name={name}
      label={label}
      options={accountTypeOptionsWithIcons}
      placeholder="Select account type"
      disabled={disabled}
    />
  );
}
